import React from 'react';
import {Header, Breadcrumb, Loader, Segment, Tab, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio, Icon} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import moment from 'moment';
import ExamenForm from "./ExamenForm";
import ManageExamen from "./ManageExamen";
import ManageExamenRespuestas from './ManageExamenRespuestas';
import ManageExamenPreguntaList from "../examenPregunta/ManageExamenPreguntaList";

const ExamenPanel=({id, idObjeto, updateIdObjeto,
                   onSave,onChange, ajaxCallInProgress, datos, errors={}, strings, permisos})=>{


     const panes = [
  {
    menuItem: 'Examen',
    render: () => <Tab.Pane attached={false}>
       
         
         <ExamenForm 
                    strings={strings}
                    id={id}
                    onChange={onChange}
                    errors={errors}
                    datos={datos}
                    onSave={onSave}      
                    ajaxCallInProgress={ajaxCallInProgress}
                    permisos={permisos}
                    strings={strings}
                    
                />
         
         </Tab.Pane>
  },
  {
    menuItem: 'Preguntas',
    render: () => 
          <div>
         {id?
                 <Tab.Pane attached={false}>
                    <ManageExamenPreguntaList
                    idForm={id}
                    strings={strings}
                        />
     
             </Tab.Pane>
        :
          <Header as='h2' icon  textAlign='center'>
                <Icon name='info circle' />
                {strings?strings["configuracion"]:""}
                <Header.Subheader>
                    {strings?strings["altaBienRobado"]:""}
                </Header.Subheader>
            </Header>
         }
          </div>
  },
  {
    menuItem: 'Visualizar Examen',
    render: () => 
          <div>
         {id?
                 <Tab.Pane attached={false}>
                    <ManageExamen
                    strings={strings}
                    idForm={id}
                />
     
             </Tab.Pane>
        :
          <Header as='h2' icon  textAlign='center'>
                <Icon name='info circle' />
                {strings?strings["configuracion"]:""}
                <Header.Subheader>
                    {strings?strings["altaBienRobado"]:""}
                </Header.Subheader>
            </Header>
         }
          </div>
  }
  
]
 
	return (
        <div >
        
            <Dimmer active={ajaxCallInProgress>0?true:false} inverted>
                    <Loader size='big' inline content={strings?strings["Procesando"]:""}/>
            </Dimmer>

            <Header dividing>             
                <Header.Content>{strings?strings["Examen"]:""}</Header.Content>
            </Header>

            <div>
            <Tab menu={{ pointing: true }} panes={panes} /> 
            </div>
         
        </div>
	);
};



export default ExamenPanel;